import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getTierCount } from '../../../../publicSession/selectors';

import { Props } from './UserMenuButton';

type StateProps = Pick<Props, 'hasSubscriptions'>;

type DispatchProps = Pick<Props, never>;

type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  hasSubscriptions: getTierCount(state) > 0,
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
